import Link from "next/link";
import type React from "react";
import type { ComponentProps } from "react";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { PropertyDealLayout } from "~/components/common/layouts/property_deals/PropertyDealLayout";
import { RelatedDealListTop } from "~/components/specifics/property_deals/[id]/RelatedDealListTop";
import { RelatedDealRow } from "~/components/specifics/property_deals/[id]/RelatedDealRow";
import { RelatedDealTotalRow } from "~/components/specifics/property_deals/[id]/RelatedDealTotalRow";
import { usePropertyDeal } from "~/hooks/usePropertyDeals";
import { useStatuses } from "~/hooks/useStatuses";
import { PATH as DEALS_PATH } from "~/pages/deals";
import Styles from "./Page.module.scss";

type StatusNameMap = Record<number, string>;
type PageProps = {
	id: number;
};

export const Page: React.FC<PageProps> = ({ id }) => {
	const { data: propertyDeal } = usePropertyDeal(id);
	const { data: statuses } = useStatuses().index();

	if (propertyDeal === null || statuses === null) {
		return null;
	}

	const statusMap: StatusNameMap = {};
	for (const status of statuses) {
		statusMap[status.id] = status.name;
	}

	const items = [
		{ as: Link, href: DEALS_PATH, label: "案件一覧" },
		{ label: "案件グループ" }
	] as const satisfies ComponentProps<typeof PropertyDealLayout>["items"];
	return (
		<DefaultV2>
			<PropertyDealLayout items={items} propertyDeal={propertyDeal}>
				<div className={Styles.Container}>
					<RelatedDealListTop propertyDeal={propertyDeal} />
					<div className={Styles.DealList}>
						{propertyDeal.deals.map((deal) => (
							<RelatedDealRow
								deal={deal}
								key={deal.id}
								propertyDealId={id}
								statuses={statusMap}
							/>
						))}
					</div>
					<RelatedDealTotalRow propertyDeal={propertyDeal} />
				</div>
			</PropertyDealLayout>
		</DefaultV2>
	);
};
